import React from 'react'
import PropTypes from 'prop-types'
import UsersStaticsDetailTableItem from "./UsersStaticsDetailTableItem"

function UsersStaticsDetailTableBody(props) {
    const {statics, error} = props

    return (
        <tbody className='UsersStaticsDetailTableBody'>
        {
            !!statics && statics.length > 0 ? statics.map((item, index) => (
                <UsersStaticsDetailTableItem key={index} item={item}/>
            )) : <tr>
                <td className="text-danger" colSpan={9}>Không tìm thấy bản ghi nào.</td>
            </tr>
        }
        {
            !!error && error.length > 0 && <tr>
                <td className="text-danger" colSpan={9}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

UsersStaticsDetailTableBody.propTypes = {
    statics: PropTypes.array,
    error: PropTypes.string
}

export default UsersStaticsDetailTableBody
